/* 
Notes:
14/03/2023 (Hams) Created
*/

import { useEffect, useState } from 'react';
import { Console } from './../../services/platform-api';
import { useSessionStorage } from '../../hooks/useSessionStorage';
import WFSettings from '../../data/platform/workflow_settings.json';

export const GetActiveConnections = () => {
  const [workatoId] = useSessionStorage('workatoId', '');
  const [cons_data, setConnectionsData] = useState([]);
  const providerNames = Object.keys(WFSettings.connectors_comboIDs);

  useEffect(() => {
    const headers = {
      'Content-type': 'application/json',
      'x-user-email': 'integrations@arcanum.ai',
      'x-user-token': '62f4f964-1743-4667-88a3-6b2d2506a159',
    };

    fetch(`/api/platform/proxy?url=api/managed_users/${workatoId}/connections/`, {
      method: 'GET',
      headers: headers,
    })
      .then((response) => response.json())
      .then((connectionRes) => {
        Console('connectionRes: ', connectionRes, 'log');
        Console('connectionRes.result: ', connectionRes?.result, 'log');
        if (connectionRes?.result) {
          const active_cons_filtered = connectionRes?.result.filter(
            (connection) =>
              connection.authorization_status === 'success' && providerNames.includes(connection.provider),
          );

          setConnectionsData(active_cons_filtered);
          Console('cons data arary: ', active_cons_filtered);
        }
      })
      .catch((err) => {
        console.error(err);
      });
  }, []);

  return {
    cons_data,
  };
};
